import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {SessionActions} from '../../../shared/actions';
import {AbstractListView} from '../../../core/visbos-core/ui/components/abstract-list-view';
import {AbstractControl, FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {AbstractVisbosControl} from '../../../core/visbos-core/ui/forms/abstract-visbos-control';
import {StockItem} from '../../../shared/view-model/store-management/stock-item.type';

@Component({
  selector: 'vb-new-assets-by-epc-list',
  templateUrl: './new-assets-by-epc-list.component.html',
  styleUrls: ['./new-assets-by-epc-list.component.css']
})
export class NewAssetsByEpcListComponent extends AbstractListView implements OnInit, OnChanges {

  @Input()
  epcs = [];

  @Input()
  article: StockItem;

  @Output()
  assetsDataChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('batchCellTmpl')
  batchCellTmpl: TemplateRef<any>;

  @ViewChild('stockAmountTmpl')
  stockAmountTmpl: TemplateRef<any>;

  @ViewChild('invNoTmpl')
  invNoTmpl: TemplateRef<any>;

  @ViewChild('serialNoTmpl')
  serialNoTmpl: TemplateRef<any>;

  messages = {
    emptyMessage: 'Keine EPCs vorhanden',
    totalMessage: 'EPCs insgesamt'
  };

  control: FormArray;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder) {
    super(sessionActions, cd);

    this.control = this.fb.array([]);

  }

  ngOnInit(): void {
    super.ngOnInit();

    this.columns = [
      {prop: 'identities.0.ean', name: 'EPC'},
      {prop: 'name', name: 'Bezeichner'},
      {prop: 'product_batch', name: 'Charge / MHD', cellTemplate: this.batchCellTmpl},
      {name: 'Seriennr.', cellTemplate: this.serialNoTmpl},
      {name: 'Inventarnr.', cellTemplate: this.invNoTmpl},
      {name: 'Bestandszähler', cellTemplate: this.stockAmountTmpl},
    ];

  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.epcs || changes.article) {
      if (this.epcs && this.article) {
        this.control = this.initControlForEPCs(this.epcs, this.article, this.fb);
        this.assetsDataChange.emit(this.control.value);
        this.addSubscription(this.control.valueChanges.subscribe(data => {
          this.assetsDataChange.emit(data)
        }));
      }
    }
  }

  deleteAsset(cuid) {
    let index = this.findCuidInFormArray(cuid, this.control);

    if (index > -1) {
      let asset = this.control.at(index).value;
      const arrayIndex = this.epcs.findIndex(e => e === asset.identities[0].ean)
      this.epcs = this.epcs.splice(arrayIndex, 1);

      this.control.removeAt(index);
      console.info("Removing item " + cuid + " from index " + index);
    }
  }

  private initControlForEPCs(epcs: string[], article: StockItem, fb: FormBuilder): FormArray {
    let formArray = fb.array([]);
    for (let epc of (epcs || [])) {
      formArray.push(this.initAssetControl(epc, article, fb));
    }
    return formArray;
  }

  applyProductBatchToAssets(productBatchControl: FormGroup) {
    if (!this.control) {
      return;
    }

    for (let c of this.control.controls) {
      if (c instanceof FormGroup) {
        c.setControl('product_batch', productBatchControl);
      }
    }

  }

  removeProductBatchFromAssets() {
    if (!this.control) {
      return;
    }
    for (let c of this.control.controls) {
      if (c instanceof FormGroup) {
        c.removeControl('product_batch');
      }
    }
  }

  private initAssetControl(epc: string, article: StockItem, fb: FormBuilder): FormGroup {

    const oldControl: AbstractControl = this.control ? this.control.at(this.findEpcInFormArray(epc, this.control)) : null;

    return fb.group({
      'cuid': AbstractVisbosControl.cuid(),
      'name': article.label,
      'article_id': article.cuid,
      'stock_count': oldControl ? oldControl.get('stock_count') : 1,
      'administration_unit_id': article.administration_unit ? article.administration_unit.cuid : null,
      'identities': fb.array([fb.group({
        'ean': epc,
        'is_seal': false
      })]),
      'inventory_no': oldControl ? oldControl.get('inventory_no') : null,
      'serial_no': oldControl ? oldControl.get('serial_no') : null
    });
  }

  findEpcInFormArray(epc: string, formArray: FormArray) {
    const val: any[] = formArray.value;
    return val.findIndex((content) => {
      return content.identities.length && content.identities[0].ean == epc;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/new-assets-by-epc-list/new-assets-by-epc-list.component.ts